<template src="./listagem-de-produto.html"></template>
<style lang="less" src="./listagem-de-produto.less" scoped></style>

<script>
import InfiniteScroll from "@/components/lists/infinite-scroll/infinite-scroll";
import Loading from "@/components/loadings/loading/loading";
import ProdutoItemCard from "./components/cards/produto-item-card/produto-item-card";
import MenuCategoriasProduto from "@/modules/loja/menu/categorias/menu-categorias-produto";
import produtoNaoEncontrado from "@/modules/erro/produto-nao-encontrado/produto-nao-encontrado";
import { mapActions, mapState } from "vuex";

const ListagemDeProduto = "ListagemDeProduto";

export default {
  components: {
    InfiniteScroll,
    Loading,
    ProdutoItemCard,
    MenuCategoriasProduto,
    produtoNaoEncontrado,
  },
  props: {
    campoDeBusca: String,
  },
  data() {
    return {
      timeoutSearchChanged: null,
    };
  },
  computed: {
    ...mapState(ListagemDeProduto, ["loading", "produtos", "loading", "done", "filtersEdit"]),
    haveItems() {
      return this.produtos?.length > 0;
    },
  },
  watch: {
    loading(newValue) {
      const scrollState = this.getScrollState();
      if (scrollState && !newValue) {
        if (this.done) scrollState.complete();
        else scrollState.loaded();
      }
    },
    done(newValue) {
      const scrollState = this.getScrollState();
      if (scrollState && !newValue) scrollState.reset();
    },
    campoDeBusca(newValue) {
      this.timeoutSearchChanged && clearTimeout(this.timeoutSearchChanged);
      this.timeoutSearchChanged = setTimeout(
        () => this.setSearchValue(newValue),
        1000
      );
    },
  },
  methods: {
    ...mapActions(ListagemDeProduto, ["setSearchValue", "incrementPage", "fetchAll"]),
    irParaAPaginaDeDetalhesDoProduto(produto) {
      this.$router.push({
        name: "produto-detalhes",
        params: { id: produto.id },
      });
    },
    getScrollState() {
      return this.$refs.scroll?.$refs?.infiniteLoading?.stateChanger;
    },
    scrollCallback() {
      const scrollState = this.getScrollState();
      if(scrollState && this.done) scrollState.complete();
      else this.incrementPage();
    }
  },
  created() {
    if(this.filtersEdit?.page === 0)
      this.incrementPage();
    else
      this.fetchAll()
  },
};
</script>